import { Account } from '@/domain/usecases'
import { UserRefundProgram } from '@/domain/usecases/refund/user-refund-program'
import { queryClient } from '@/infra/http'
import { importRemote } from '@/main/routes/helpers/loaders'

/**
 * Loads refund request data for a specific program
 * Fetches account profile and program details
 */
export async function loadRefundRequest(id: string) {
  const [accountProfile, program] = await Promise.all([
    importRemote<Account>('makeRemoteAccountProfile', queryClient).then(remote => remote.loader()),
    importRemote<UserRefundProgram>('makeRemoteUserRefundProgram', queryClient).then(remote =>
      remote.get(id)
    )
  ])

  return {
    accountProfile,
    program
  }
}
